const cookieBannerStrings = {
    body: "To ensure that you have the best possible experience while visiting us, we use cookies and similar technologies.",
    accept: "Accept",
    decline: "Decline",
};

export default cookieBannerStrings;
